import React from 'react';
import AppUpsellModal from './AppUpsellModal';
import AppUpsellBanner from './AppUpsellBanner';
import { useAppUpsell } from '@hooks/useAppUpsell';

/**
 * Mobile-app upsell for My Team pages: modal on first (and then weekly)
 * eligible visit, bottom banner on every visit in between. All gating lives
 * in useAppUpsell; this component only renders the chosen surface.
 */
const AppUpsell = () => {
  const { upsellState, storeUrl, ctaLabel, isAppView, dismiss } =
    useAppUpsell();

  if (upsellState === 'hidden') return null;

  return upsellState === 'modal' ? (
    <AppUpsellModal
      storeUrl={storeUrl}
      ctaLabel={ctaLabel}
      onCtaClick={dismiss}
      onClose={dismiss}
    />
  ) : (
    <AppUpsellBanner
      storeUrl={storeUrl}
      ctaLabel={ctaLabel}
      onCtaClick={dismiss}
      onClose={dismiss}
      isAppView={isAppView}
    />
  );
};

export default AppUpsell;
